export default __webpack_public_path__ + "static/media/image_icon.711b2f6d.png";